import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { sendForgotOTP, resetPassword } from "../../services/api";
import "../../vendor-panel.css";
import logo from "../../assets/vangle.jpeg";

const VendorForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSendOTP = async () => {
    if (!email.trim()) return setMessage("Please enter your email.");
    setLoading(true);
    setMessage("");
    try {
      const res = await sendForgotOTP(email);
      if (res.data.success) { setMessage("✅ OTP sent to your email!"); setStep(2); }
      else setMessage(res.data.message || "Failed to send OTP.");
    } catch { setMessage("⚠️ Failed to send OTP. Please try again."); }
    finally { setLoading(false); }
  };

  const handleResetPassword = async () => {
    if (!otp.trim() || !newPassword.trim()) return setMessage("Fill all fields.");
    setLoading(true);
    setMessage("");
    try {
      const res = await resetPassword(email, otp, newPassword);
      if (res.data.success) { alert("Password reset successfully!"); navigate("/vendor/login"); }
      else setMessage(res.data.message || "Failed to reset.");
    } catch { setMessage("⚠️ Error resetting password."); }
    finally { setLoading(false); }
  };

  return (
    <div className="vp-auth-wrapper">
      <div className="vp-auth-container">
        <div className="vp-auth-brand">
          <img src={logo} alt="V Angel Coin" />
          <h1>V Angel Coin</h1>
          <p>Vendor Partner Portal</p>
        </div>

        <div className="vp-auth-card">
          <h2>Reset Password</h2>
          <p className="sub">{step === 1 ? "Enter your email to receive an OTP" : "Enter the OTP and your new password"}</p>

          <div className="vp-step-text">Step {step} of 2</div>

          {message && (
            <div className={`vp-alert ${message.startsWith("✅") ? "vp-alert-success" : "vp-alert-error"}`}>
              {message}
            </div>
          )}

          <div className="vp-form">
            {step === 1 ? (
              <>
                <div className="vp-form-group">
                  <label>Registered Email Address</label>
                  <input className="vp-input" type="email" placeholder="you@business.com" value={email} onChange={e => setEmail(e.target.value)} disabled={loading} />
                </div>
                <button className="vp-btn vp-btn-primary vp-btn-lg vp-btn-full" onClick={handleSendOTP} disabled={loading || !email.trim()}>
                  {loading ? "Sending OTP..." : "Send OTP"}
                </button>
              </>
            ) : (
              <>
                <div className="vp-form-group">
                  <label>OTP Code</label>
                  <input className="vp-input" type="text" placeholder="Enter OTP from email" value={otp} onChange={e => setOtp(e.target.value)} disabled={loading} />
                </div>
                <div className="vp-form-group">
                  <label>New Password</label>
                  <input className="vp-input" type="password" placeholder="Enter new password" value={newPassword} onChange={e => setNewPassword(e.target.value)} disabled={loading} />
                </div>
                <button className="vp-btn vp-btn-primary vp-btn-lg vp-btn-full" onClick={handleResetPassword} disabled={loading || !otp.trim() || !newPassword.trim()}>
                  {loading ? "Resetting..." : "Reset Password"}
                </button>
                <button className="vp-btn vp-btn-ghost vp-btn-full" onClick={() => { setStep(1); setMessage(""); }} style={{ marginTop: 6 }}>
                  ← Resend OTP
                </button>
              </>
            )}
          </div>

          <div className="vp-auth-footer">
            <Link to="/vendor/login">← Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorForgotPassword;
